import { Box, LoadingOverlay } from '@mantine/core';
import dayjs from 'dayjs';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Field } from 'redux-form';
import Banner from '../../elements/Banner';
import Button from '../../elements/Button';
import InputDate from '../../elements/DatePicker/DatePicker';
import ImagePicker from '../../elements/ImagePicker/ImagePicker';
import LoadingBars from '../../elements/LoadingBars';
import Tab from '../../elements/Tab/Tab';
import Toogle from '../../elements/Toogle';
import RichTextInput from '../../fields/RichTextInput';
import Text from '../../fields/Text';
import TextArea from '../../fields/TextArea';
import IconWarning from '../../icons/IconWarning';
import { fieldsProps } from './schema';
import styles from './styles.scoped.css';
import { notificationTypeNumber } from '../../../pages/Notification/constants';

export default function Component({
  onSubmit, showNotificationExample, setShowPreviewNotification,
  isLoading, handleGoBack, showError, setShowError, change, isEdit, data
}) {
  dayjs.extend(require('dayjs/plugin/isBetween'));
  const {
    type, title, description, content, contentImage, startDate, endDate, status,
    banner
  } = fieldsProps;
  const [statusValue, setStatusValue] = useState({ isChecked: false, label: 'Tidak Aktif' });
  const { values } = useSelector((state) => state.form.notificationForm);
  const [image, setImage] = useState([]);
  const [bannerImage, setBannerImage] = useState([]);
  const [typeSelected, setTypeSelected] = useState(
    notificationTypeNumber[data?.type] || type.defaultValue
  );

  useEffect(() => {
    if (isEdit) {
      change('title', data?.title);
      change('description', data?.description);
      change('content', data?.content);
      change('startDate', new Date(data?.startDate));
      change('endDate', new Date(data?.endDate));
      setTypeSelected(notificationTypeNumber[data?.type]);
    }
  }, [data]);

  const buttonValidation = () => {
    if (typeSelected === '1') {
      if (!isEdit)
        return (values.title && values.description && values.content
          && bannerImage.length > 0 && values.startDate && values.endDate);
      else
        return (values.title && values.description && values.content
          && values.startDate && values.endDate);
    } else if (typeSelected === '2') {
      return (values.title && values.content && values.startDate && values.endDate);
    } else if (typeSelected === '3') {
      if (isEdit)
        return (values.title && values.startDate && values.endDate);
      else
        return (values.title && image.length > 0
          && values.startDate && values.endDate && bannerImage.length > 0);
    }
  };

  const buttonValidationPreview = () => {
    if (typeSelected === '1') {
      if (!isEdit)
        return (values.title && values.description && values.content && bannerImage.length > 0);
      else return (values.title && values.description && values.content);
    } else if (typeSelected === '2') {
      return (values.title && values.content);
    } else if (typeSelected === '3') {
      if (!isEdit)
        return (values.title && image.length > 0 && bannerImage.length > 0);
      else return (values.title);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const payload = {
      ...values,
      imageContent: image,
      banner: bannerImage,
      type: typeSelected,
    };

    onSubmit(typeSelected, payload);
  };

  const showPreview = async () => {
    const payload = {
      ...values,
      contentImage: image.length > 0 && URL.createObjectURL(image[0]),
      banner: bannerImage.length > 0 && URL.createObjectURL(bannerImage[0]),
      type: typeSelected,
    };
    setShowPreviewNotification({ isShow: true, payload });
  };

  useEffect(() => {
    setShowError({ isShow: false, message: '' });
    if (values.startDate && values.endDate) {
      if (values.endDate < values.startDate) {
        change('endDate', values.startDate);
      }
      if (dayjs(dayjs().format('YYYY-MM-DD')).isBetween(values.startDate, dayjs(values.endDate), 'day', '[]')) {
        setStatusValue({ isChecked: true, label: 'Aktif' });
      } else {
        setStatusValue({ isChecked: false, label: 'Tidak Aktif' });
      }
    }
  }, [values]);

  return (
    <Box className={styles['wrapper']} pos="relative">
      <LoadingOverlay overlayProps={{ radius: 'sm', blur: 2 }} visible={isLoading} zIndex={1000} />
      <form className={styles['form-wrapper']} onSubmit={handleSubmit}>
        <Tab
          data={type.data}
          defaultValue={typeSelected}
          disabled={isEdit}
          inputProps={type}
          name={type.name}
          onChange={(e) => {
            setTypeSelected(e);
          }}
          required
          type="default" />

        <Button
          className={styles['btn-action']}
          onClick={showNotificationExample}
          outlined style={'blue'}
          type="button">Lihat Contoh Tampilan Notifikasi</Button>

        <Field
          component={Text}
          inputProps={title}
          name={title.name}
          required />

        {typeSelected === '1' &&
          <Field
            component={TextArea}
            inputProps={description}
            name={description.name}
            required />
        }

        {(typeSelected === '1' || typeSelected === '2') &&
          <Field
            component={RichTextInput}
            initialValue={isEdit ? data?.content : ''}
            inputProps={content}
            label={content.label}
            name={content.name}
            required />
        }

        {(typeSelected === '3') &&
          <ImagePicker
            defaultValue={data?.imageContent}
            height={contentImage.height}
            info={contentImage.info}
            isPixelCheck={true}
            maxSize={2000000}
            onSelect={setImage}
            required
            title={contentImage.label}
            width={contentImage.width}
          />
        }

        {(typeSelected === '1' || typeSelected === '3') &&
          <ImagePicker
            defaultValue={data?.banner}
            height={banner.height}
            info={banner.info}
            isPixelCheck={true}
            maxSize={2000000}
            onSelect={setBannerImage}
            required
            title={banner.label}
            width={banner.width}
          />}

        <div className={styles['form-group']}>
          <Field
            className={styles.datePicker}
            component={InputDate}
            inputProps={startDate}
            minDate={new Date()}
            name={startDate.name}
            required />
          <Field
            className={styles.datePicker}
            component={InputDate}
            inputProps={endDate}
            minDate={values.startDate}
            name={endDate.name}
            required />
        </div>
        <Field
          checked={statusValue.isChecked}
          color="green"
          component={Toogle}
          inputProps={status}
          name={status.name}
          valueLabel={statusValue.label}
        />
        {showError.message ? (
          <Banner
            className={styles['banner']}
            desc={showError.message}
            icon={<IconWarning />}
            type={'warning'} />
        ) : <></>
        }

        <Button
          className={styles['btn-action']}
          disabled={!buttonValidationPreview()}
          onClick={showPreview}
          outlined
          type="button">
          Preview Tampilan
        </Button>

        <div className={styles['action-group']}>
          <Button
            className={styles['btn-action']}
            onClick={handleGoBack}
            outlined
            type="button">
            Kembali
          </Button>
          <Button
            className={styles['btn-action']}
            disabled={!buttonValidation() || isLoading}
            style={'blue'}
            type="submit">
            {isLoading ? <span><LoadingBars /> Menyimpan</span> : 'Simpan'}
          </Button>
        </div>
      </form>
    </Box>
  );
}

Component.propTypes = {
  change: PropTypes.func.isRequired,
  data: PropTypes.object,
  handleGoBack: PropTypes.func,
  isEdit: PropTypes.bool,
  isLoading: PropTypes.bool,
  onSubmit: PropTypes.func,
  setShowError: PropTypes.func,
  setShowPreviewNotification: PropTypes.func,
  showError: PropTypes.object,
  showNotificationExample: PropTypes.func,
};
